import useSWR, { SWRResponse } from "swr";
import { IUseAmlStatus } from "./types";
import { IAmlStatus } from "@portal/types/api/IAmlStatus";
import useAdvisor from "../useAdvisor";
import commonSwrConfig from "../commonSwrConfig";
import { useSession } from "@portal/auth/client/SessionProvider";
import { commonFetcher } from "../common/commonFetcher";

const useAmlStatus: IUseAmlStatus = () => {
  const { update } = useSession();
  const { isAdvisorAndNoImpersonation } = useAdvisor();

  const { data, isLoading, error, mutate }: SWRResponse<IAmlStatus, unknown> = useSWR(
    !isAdvisorAndNoImpersonation ? `/api/amlStatus` : null,
    commonFetcher<IAmlStatus>,
    {
      ...commonSwrConfig(update),
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true,
    },
  );

  return {
    data,
    error,
    isLoading,
    mutate,
  };
};

export default useAmlStatus;
